// extracted by mini-css-extract-plugin
module.exports = {"badgeListcontainer":"_1upi7jQxpef5edIy2F1DrR"};